// Copyright © 2019 The Things Network Foundation, The Things Industries B.V.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import { defineMessages } from 'react-intl'

export default defineMessages({
  // Keep these sorted alphabetically.
  additionalInformation: 'Additional Information (please attach to error inquiries)',
  contactAdministrator: 'If the error persists after refreshing, please contact an administrator',
  error: 'Error',
  genericError: 'An unknown error occurred. Please try again later.',
  genericNotFound: 'The page you requested cannot be found',
  subviewErrorExplanation: 'There was a problem when displaying this section',
  subviewErrorTitle: "We're sorry!",
  unknownErrorTitle: 'An unknown error occurred',
})
